import dayjs from "dayjs";
import { ItemMenu } from "../../../../../../../components/baseMenu";
import { TimeZoneGneral } from "../../shared/detail/types";
import { ConfirmActivityAction } from "../../shared/detail/utils/enums";
import { ActivityMenuItem, Hashs } from "../utils";
import { CancelActivity, ConfirmActiveOrFinish, DeleteActivity, FinishForcedActivity, ReScheduleActivity, ResendActivity, SeeReport  } from "../utils/types";

export const menuOptions = ({ item, payload }: { item: ItemMenu, payload?: { someIsRequired:boolean; timeZone: TimeZoneGneral; geofence:boolean; initDate:dayjs.Dayjs | null, endDate:dayjs.Dayjs | null; storePoint:{lat:string,lng:string;locationInitSiteName:string;} ; id?: string; resend:ResendActivity, reScheduleActivity:ReScheduleActivity, forcedFinish:FinishForcedActivity, cancelActivity:CancelActivity, deleteActivity: DeleteActivity, startActivity: ConfirmActiveOrFinish, finishActivity: ConfirmActiveOrFinish, seeReport: SeeReport } }) => {
    switch (item.value) {
        case ActivityMenuItem.SEE_REPORT: {
            const [userId, activityId] = payload?.id?.split('-') ?? []
            if(payload?.id) {
                payload.seeReport({ id: activityId })
            }
            break
        }
        case ActivityMenuItem.EDIT: {
            const [userId, activityId] = payload?.id?.split('-') ?? []
            window.location.hash = `${Hashs.EDIT}-${activityId}`
            break
        }
        /* case ActivityMenuItem.DETAIL: {
            const [userId, activityId] = payload?.id?.split('-') ?? []
            window.location.hash = `${Hashs.DETAIL}-${activityId}`
            break
        } */
        case ActivityMenuItem.DELETE: {
            const [userId, activityId] = payload?.id?.split('-') ?? []
            if(payload?.id) {
                payload.deleteActivity({ id: activityId })
            }
            break
        }
        case ActivityMenuItem.RESCHEDULE: {
            const [userId, activityId] = payload?.id?.split('-') ?? []
            if(payload?.id) {
                payload.reScheduleActivity({ id: activityId, endDate:payload.endDate, startDate:payload.initDate, timeZone:payload.timeZone })
            }
            break
        }
        case ActivityMenuItem.RESEND_INFORM: {
            const [userId, activityId] = payload?.id?.split('-') ?? []
            if(payload?.id) {
                payload.resend({ id: activityId, timeZone:payload.timeZone })
            }
            break
        }
        case ActivityMenuItem.CANCEL: {
            const [userId, activityId] = payload?.id?.split('-') ?? []
            if(payload?.id) {
                payload.cancelActivity({ id: activityId })
            }
            break
        }
        case ActivityMenuItem.FINISH: {
            const [userId, activityId] = payload?.id?.split('-') ?? []
            if(payload?.id) {
                payload.finishActivity({ action:ConfirmActivityAction.FINISH, initDate:payload.initDate, id: activityId, geofence:payload.geofence, someIsRequired:payload.someIsRequired, storePoint:payload.storePoint })
            }
            break
        }
        case ActivityMenuItem.FORCEDFINISH: {
            const [userId, activityId] = payload?.id?.split('-') ?? []
            if(payload?.id) {
                payload.forcedFinish({ id: activityId, geofence:payload.geofence, storePoint:payload.storePoint })
            }
            break
        }
        case ActivityMenuItem.START: {
            const [userId, activityId] = payload?.id?.split('-') ?? []
            if(payload?.id) {
                payload.startActivity({ action:ConfirmActivityAction.START, someIsRequired:payload.someIsRequired, id: activityId, geofence:payload.geofence, initDate:payload?.initDate, storePoint:payload.storePoint })
            }
            break
        }
    }
}